export const dev_host = "https://pcshop.mcruanjian.cn"; // 开发环境域名
export const product_host = "https://www.kwecp.com"; // 生产环境域名
export const IS_DEV = 0; // 0:生产环境 1:开发环境 2:mock环境
const host = IS_DEV == 1 ? dev_host : product_host; // 项目中接口地址host

export const BASE_URL = `${host}`; // 基础路径
export const API_BASE_URL = `${host}/api`; // 接口请求基础路径



// WEBPACK FOOTER //
// ./src/utils/config.js